<template>
  <c-table
    ref="table"
    :title="'이탈(' + popupParam.deviationName + ')별 가능한 원인 목록'"
    :columns="grid.columns"
    :gridHeight="grid.height"
    :data="grid.data"
    :filtering="false"
    :columnSetting="false"
    :usePaging="false"
    :editable="editable"
    :selection="popupParam.type"
    rowKey="ramVariableGuidewordId"
    @rowDblclick="rowDblclick"
  >
    <!-- 버튼 영역 -->
    <template slot="table-button">
      <q-btn-group outline >
        <c-btn v-if="editable" label="LBLSELECT" icon="check" @btnClicked="select" />
      </q-btn-group>
    </template>
  </c-table>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'hazop-cause-pop',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        type: 'multiple',
        // 대상공정의 구분을 확인 후 해당 구분에 맞게 목록을 조회 (회분식, 연속식)
        processType: '',
        // 위험형태 key를 제공받아 해당 key를 토대로 목록을 조회토록 설정
        ramVariableId: '',
        ramVariableGuidewordCd: '',
        deviationName: '',
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'causeName',
            field: 'causeName',
            label: '가능한원인',
            align: 'left',
            style: 'width:350px',
            sortable: true,
          },
        ],
        data: [],
        height: '650px'
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  watch: {
    contentHeight() {
      this.grid.height = (this.contentHeight - 50) + 'px'
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.variableCause.list.url
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        ramVariableId: this.popupParam.ramVariableId,
        ramVariableGuidewordCd: this.popupParam.ramVariableGuidewordCd,
      }
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: '원인을 하나 이상 지정하세요.', // 원인을 하나 이상 지정하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$_.forEach(selectData, item => {
          item.deviationName = this.popupParam.deviationName;
        })
        this.$emit('closePopup', selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === 'single') {
        this.$emit('closePopup', [row]);
      }
    },
  }
};
</script>
